import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Logo from "@/components/Logo";
import { EASY_MASSAGE_URL } from "@/lib/assets";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-gray-50 border-t border-gray-200 py-16 px-6 md:px-12">
      <div className="max-w-7xl mx-auto grid gap-12 md:grid-cols-4">
        <div className="md:col-span-2 max-w-sm">
          <Logo />
          <p className="mt-5 text-gray-600 leading-relaxed">
            Easy Booking solutions for your industry that work. Beautiful, fully-bookable
            websites for service businesses — starting with massage, and more industries coming soon.
          </p>
        </div>

        <div>
          <h4 className="font-heading font-bold text-sm uppercase tracking-wider text-[#0A0A0A] mb-4">
            Pages
          </h4>
          <ul className="space-y-3 text-gray-600">
            <li><Link to="/" data-testid="footer-home" className="hover:text-[#3EA65B]">Home</Link></li>
            <li><Link to="/industries" data-testid="footer-industries" className="hover:text-[#3EA65B]">Industries</Link></li>
            <li><Link to="/about" data-testid="footer-about" className="hover:text-[#3EA65B]">About</Link></li>
            <li><Link to="/contact" data-testid="footer-contact" className="hover:text-[#3EA65B]">Contact</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-heading font-bold text-sm uppercase tracking-wider text-[#0A0A0A] mb-4">
            Our Brands
          </h4>
          <ul className="space-y-3 text-gray-600">
            <li>
              <a href={EASY_MASSAGE_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-easymassage" className="inline-flex items-center gap-1 hover:text-[#3EA65B]">
                Easy Massage <ArrowUpRight className="h-3.5 w-3.5" />
              </a>
            </li>
            <li className="text-gray-400">Easy Detailing <span className="text-[#3EA65B] text-xs font-semibold">(Coming soon)</span></li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto mt-12 pt-8 border-t border-gray-200 flex flex-col sm:flex-row justify-between gap-3 text-sm text-gray-500">
        <p>© {new Date().getFullYear()} Easy Booking Solutions. All rights reserved.</p>
        <p>Australia · Built for service businesses</p>
      </div>
    </footer>
  );
};

export default Footer;
